import {get, post, put, del} from "@/utils/request";

// 新增关联系统
export function addAssociatedSystem(data) {
    return post('/associatedSystem/add', data)
}
//获取关联系统列表
export function getList(data){
    return get('/associatedSystem/list',data)
}
//获取所有关联系统列表
export function getAllList(){
    return get('/associatedSystem/all')
}
//修改关联系统
export function updateAssociatedSystem(data){
    return put('/associatedSystem/update',data)
}
//删除关联系统
export function deleteAssociatedSystem(data){
    return del('/associatedSystem/delete',data)
}
